<template>
  <div>
    <div class="accordion-header" @click="handleAccordionClick">
      {{ label }}
      <icon name="arrow-up" v-if="isActive" />
      <icon name="arrow-down" v-else />
    </div>
    <div :id="_uid" class="panel">
      <div class="inner-panel">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: { type: String, default: null }
  },

  data() {
    return {
      isActive: false
    };
  },

  methods: {
    handleAccordionClick() {
      this.isActive = !this.isActive;

      const panel = document.getElementById(this._uid);
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
        return;
      }

      const animationCompleted = () => {
        panel.style.maxHeight = "max-content";
        panel.removeEventListener("transitionend", animationCompleted, false);
      };

      panel.addEventListener("transitionend", animationCompleted, false);

      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  }
};
</script>

<style scoped>
.accordion-header {
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  outline: none;
  transition: 0.4s;
}

.panel {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.2s ease-out;
}

.inner-panel {
  padding: 1rem;
}
</style>
